<template>
	<v-container class="pa-0 overflow-hidden" fluid fill-height justify-start>
		<v-layout column justify-start>
			<v-flex shrink class="white">
				<slot name="toolbar" />
				<v-divider />
			</v-flex>
			
			<v-flex fill-height v-if="loading">
				<v-layout fill-height justify-center align-center class="grey lighten-5">
					<v-progress-circular indeterminate color="primary" />
				</v-layout>
			</v-flex>

			<v-flex class="scroll-y pa-0 grey lighten-5" v-else>
				<slot />
			</v-flex>

			<v-flex shrink class="white">
				<slot name="footer" />
			</v-flex>
		</v-layout>
	</v-container>
</template>


<script>
export default {
	props: {
		loading: { type: Boolean, default: false }
	}
}
</script>
